import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { CaretDownIcon, CaretUpIcon, InfoIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import { getTitleAndMessage } from './helpers'
import * as Styles from './styles'

const InformationAboutPaymentAndRefund = ({
  isInstant,
  exchangedForOrder,
  transactionType,
  paymentStatus,
  transactionStatus,
  issueExchangeAtStatus,
  remainingAmount,
  summaryTotalAmount,
  refundStatus,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const [showMessage, setShowMessage] = useState(false)
  const containerRef = useRef(null)
  const { title, message } = getTitleAndMessage({
    isInstant,
    exchangedForOrder,
    transactionType,
    paymentStatus,
    transactionStatus,
    issueExchangeAtStatus,
    remainingAmount,
    summaryTotalAmount,
    refundStatus,
  })

  if (!title || !message) return null

  const handleToggleMessage = () => {
    setShowMessage(showMessage => !showMessage)
  }

  return (
    <Styles.Container>
      <Styles.HeaderContainer onClick={handleToggleMessage}>
        <Styles.TitleContainer>
          <InfoIcon size={24} color={theme.colors.text.link.default} />
          <Text type="bodySBold">{t(title)}</Text>
        </Styles.TitleContainer>
        <Styles.CaretContainer collapsed={!showMessage}>
          {showMessage ? <CaretUpIcon size={24} /> : <CaretDownIcon size={24} />}
        </Styles.CaretContainer>
      </Styles.HeaderContainer>
      <Styles.MessageContainer
        collapsed={!showMessage}
        height={containerRef.current?.scrollHeight || 100}
        ref={containerRef}
      >
        <Text type="bodySRegular">{t(message)}</Text>
      </Styles.MessageContainer>
    </Styles.Container>
  )
}

export default InformationAboutPaymentAndRefund
